import React from 'react';
import moment from 'moment';
import nl2br from 'react-br';

export default class ChatMessage extends React.PureComponent {
    render() {
        let {message} = this.props,
            classes = ["ChatMessage"];

        if (this.props.isMine) {
            classes.push('mine');
        }

        return <div className={classes.join(' ')}>
            <div className="content">{nl2br(message.message)}</div>
            <div className="timestamp">
                {moment.utc(message.postedOn).local().format('llll')}
            </div>
        </div>;
    }
}
